import Vue from 'vue'
import VueRouter from 'vue-router'
import util from '@/index/libs/util.js'
import _ from 'underscore'
// 路由数据
import routes from './routes'

Vue.use(VueRouter)

// 导出路由 在 main.js 里使用
const router = new VueRouter({
  routes
})

/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach((to, from, next) => {
  // 验证当前路由所有的匹配中是否需要有登陆验证的
  if ((window.sessionStorage.getItem('state') && window.sessionStorage.getItem('state') === 'true') && to.name === 'operateHomeTotal' && from.name === 'login') {
    next({
      name: 'home'
    })
    return
  }
  if ((window.sessionStorage.getItem('state') && window.sessionStorage.getItem('state') === 'true') && (to.meta.statue || to.name === 'login') && (from.meta.statue || from.name === 'login')) {
    next()
    return
  } else if ((window.sessionStorage.getItem('state') && window.sessionStorage.getItem('state') === 'true') && !to.meta.statue && from.meta.statue) {
    next({
      name: from.name
    })
    return
  }
  if ((window.sessionStorage.getItem('state') && window.sessionStorage.getItem('state') === 'false') && to.meta.statue && (!from.meta.statue || from.name === 'login')) {
    // next({
    //   name: from.name
    // })
    return
  }
  if (to.matched.some(r => r.meta.requiresAuth)) {
    // 这里暂时将cookie里是否存有token作为验证是否登陆的条件
    // 请根据自身业务需要修改
    const token = util.cookies.get('token')
    if (token && token !== 'undefined') {
      console.log(window.localStorage.getItem('state'))
      next()
    } else {
      // 没有登陆的时候跳转到登陆界面
      // next()
      next({
        name: 'login'
      })
    }
  } else {
    // 不需要身份校验 直接通过
    next()
  }
})

router.afterEach(to => {
  // 需要的信息
  const app = router.app
  const { name, params, query, matched } = to
  app.$store.commit('d2adminPageOpenNew', { name, params, query, matched })
  util.title(to.meta.title)
})

export default router
